import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';
import blogPosts from '../../data/marketing/blogPosts.json';

const published = blogPosts.filter((post) => !post.isDraft);

export default function BlogIndexPage() {
  return (
    <MarketingShell
      title="Blog"
      description="Notes on grants, savings, hiring, and running a company."
    >
      <ul className="divide-y divide-gray-100 rounded-xl border border-gray-100 bg-white">
        {published.map((post) => (
          <li key={post.slug}>
            <Link
              to={`/post/${post.slug}`}
              className="block px-6 py-5 hover:bg-gray-50 transition-colors"
            >
              <p className="text-sm font-semibold text-gray-900">{post.name}</p>
              <p className="mt-1 text-xs text-gray-400">
                {post.publishedAt ? new Date(post.publishedAt).toLocaleDateString('en-CA') : ''}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </MarketingShell>
  );
}
